import { __assign } from "tslib";
/**
 *  An iframe that sandboxes wix-dealer ads rendered by our da-wix-dealer app
 *  the app communicates with this component using the postMessage api, telling
 *  it whether an ad was loaded ('ad-filled') or none is available ('ad-empty')
 */
import React, { useCallback, useState, useEffect, useContext } from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import s from './DealerAdIframe.scss';
var IFRAME_TITLE = 'DealerAdIframe';
var DEALER_RUNNING_LOCALLY = false;
var ADS_ENDPOINT = DEALER_RUNNING_LOCALLY
    ? 'http://localhost:5000/_adslot'
    : 'https://www.deviantart.com/_adslot';
var WIX_DEALER_MESSAGE_TYPE = 'dealerAd';
// this next id can be used to test the system and should always be available
export var TEST_REALESTATEID = 'd4c58bed-9276-439f-b040-36472ccfba3c';
var DealerAdIframe = function (props) {
    var realEstateId = props.realEstateId, userGuid = props.userGuid, biClientId = props.biClientId, biClientIdSigned = props.biClientIdSigned, showAndCollapse = props.showAndCollapse, className = props.className, showDealerPopup = props.showDealerPopup;
    var noDealerAds = useFlag('no_dealer_ads'); // do not show ads at all, useful for storybook and such
    var fakeAds = useFlag('yumeruby'); // show a placeholder instead of the iframe, useful for debugging
    var adsEnabled = useContext(SessionContext).adsEnabled;
    var _a = useState(false), collapsed = _a[0], setCollapsed = _a[1];
    var handler = useCallback(function (data) {
        switch (data.command) {
            case 'ad-empty':
            case 'ad-filled':
                if (fakeAds) {
                    setCollapsed(false);
                }
                else {
                    setCollapsed(showAndCollapse
                        ? data.command === 'ad-empty'
                        : data.command !== 'ad-filled');
                }
                break;
            case 'show-modal':
                showDealerPopup(data.data);
                break;
            default:
                break;
        }
    }, [fakeAds, showDealerPopup, showAndCollapse]);
    useWixDealerListener(realEstateId, handler);
    // When we have display ads, don't use dealer
    if (noDealerAds || adsEnabled) {
        return null;
    }
    var classNames = classnames(s['root'], collapsed && s['collapsed'], className);
    var paramsToSend = new URLSearchParams(Object.entries({
        realEstateId: realEstateId,
        userGuid: userGuid,
        biClientId: biClientId,
        biClientIdSigned: biClientIdSigned,
        newApi: 2,
    }).filter(function (e) { return e[1]; }));
    var iframeProps = {
        loading: 'lazy',
        scrolling: 'no',
        frameBorder: '0',
        style: { border: '0px' },
    };
    if (fakeAds) {
        return (React.createElement("div", { style: { background: 'lightskyblue', overflow: 'auto' }, className: classNames }, realEstateId));
    }
    return (React.createElement("iframe", __assign({ className: classNames }, iframeProps, { title: IFRAME_TITLE, src: "".concat(ADS_ENDPOINT, "/?").concat(paramsToSend) })));
};
DealerAdIframe.displayName = 'DealerAdIframe';
// ------------
/** Listen to 'message' events from an iframe containing the da-wix-dealer
 *  app and filtering by a realEstateId */
function useWixDealerListener(realEstateId, handler) {
    useEffect(function () {
        var messageHandler = function (event) {
            if (event.data &&
                event.data.type === WIX_DEALER_MESSAGE_TYPE &&
                event.data.realEstateId === realEstateId) {
                handler(event.data);
            }
        };
        window.addEventListener('message', messageHandler);
        return function () {
            window.removeEventListener('message', messageHandler);
        };
    }, [realEstateId, handler]);
}
// never, ever re-render the iframe
export default React.memo(DealerAdIframe, function () { return true; });
//# sourceMappingURL=DealerAdIframe.js.map